<template>
  <v-container fluid>
    <v-row v-if="false" class="d-flex align-center justify-center" style="height: 100vh">
      <div>
        <h1 class="d-flex justify-center">Upss
          <v-icon class="ml-3" color="black" large>fa-regular fa-grin-beam-sweat</v-icon>
        </h1>
        <h3 class="d-flex justify-center mt-7">Swiset isn't available on mobile</h3>
        <p class="d-flex justify-center">Please open the app on a laptop or desktop.</p>
        <v-btn class="d-flex justify-center mt-5" style="width: 100%" @click="goToWebsite">But, visit our website »
        </v-btn>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "MobileNote",
  data() {
    return {
      landingKey: '',
      highlight: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if(this.$route.query.landingKey !== undefined)
        this.landingKey = this.$route.query.landingKey;
      if(this.$route.query.highlight !== undefined)
        this.highlight = this.$route.query.highlight;
      window.open('https://onelink.to/97xuy6',"_self");
    },
    goToWebsite() {
      window.open('https://swiset.com/');
    },
  }
}
</script>

<style scoped>

</style>
